export const DEFAULT_CURRENT_HOME_CARE_SERVICE = {
  '無': false,
  '居家醫療': false,
  '居家護理': false,
  '居家服務': false,
  '其他': '',
}